export enum SignInFlow {
	REGISTERED,
	CONVERTED,
	LOGIN,
}
